export const isProductTag = (categoryId, productTags = []) => {
  return (
    productTags?.length && productTags.findIndex((tag) => tag.id === categoryId) >= 0
  );
};
